import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const MinusIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", width: sizePx, style: styles, ...rest },
        React.createElement("path", { d: "M3 10h14", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
export default MinusIcon;
//# sourceMappingURL=index.js.map